.field {
	display: flex;
	flex-direction: column;
	font: var(--lp-text-label-1-regular);
	gap: var(--lp-spacing-200);
}
